import selectTotalFields from './select-total-fields';
import {createSelector} from '@reduxjs/toolkit';

export default createSelector([selectTotalFields], totals => {
  return totals.public_price;
});
